/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Past_DividerInputs */



/**
* | output |
* | --- |
* | "Past events" |
*
* @param {Tournaments_Past_DividerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_past_divider = /** @type {((inputs?: Tournaments_Past_DividerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Past_DividerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements passés")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos pasados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Eventos passados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi passati")
	return /** @type {LocalizedString} */ ("Past events")
});